import Chip from '@material-ui/core/Chip';
import PropTypes from 'prop-types';
import makeStyles from '@material-ui/core/styles/makeStyles';
import React from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      borderRadius: '0',
      fontWeight: theme.typography.fontWeightBold,
      '& .MuiChip-avatar': {
        color: 'inherit'
      }
    },
    primary: {
      backgroundColor: colors.primary.light,
      color: colors.primary.main
    },
    secondary: {
      backgroundColor: colors.secondary.light,
      color: colors.secondary.main
    },
    lime: {
      backgroundColor: colors.lime.light,
      color: colors.lime.main
    },
    error: {
      backgroundColor: colors.error.light,
      color: colors.error.main
    },
    grey: {
      backgroundColor: colors.grey.medium,
      color: colors.grey.dark
    }
  };
});

const Label = ({ themeColor, size, icon, text, ...rest }) => {
  const classes = useStyles();
  return (
    <Chip
      className={`${classes.root} ${classes[themeColor] || classes.darkBlue}`}
      size={size}
      avatar={icon}
      label={text}
      {...rest}
    />
  );
};

Label.propTypes = {
  themeColor: PropTypes.oneOf(['primary', 'secondary', 'lime', 'error', 'grey']),
  size: PropTypes.oneOf(['small', 'medium']),
  icon: PropTypes.node,
  text: PropTypes.string.isRequired
};

Label.defaultProps = {
  themeColor: 'primary',
  size: 'medium',
  icon: null
};

export default Label;
